const ca = {
  // ============================================================
  // COMMON — Compartit a tota l'aplicació
  // ============================================================
  common: {
    loading: 'Carregant...',
    error: 'Error',
    save: 'Desar',
    cancel: 'Cancel·lar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    add: 'Afegir',
    remove: 'Eliminar',
    close: 'Tancar',
    confirm: 'Confirmar',
    apply: 'Aplicar',
    reset: 'Restablir',
    search: 'Cercar',
    filter: 'Filtrar',
    clear: 'Esborrar',
    back: 'Enrere',
    next: 'Següent',
    previous: 'Anterior',
    submit: 'Enviar',
    update: 'Actualitzar',
    refresh: 'Actualitzar',
    export: 'Exportar',
    import: 'Importar',
    download: 'Descarregar',
    upload: 'Pujar',
    print: 'Imprimir',
    copy: 'Copiar',
    yes: 'Sí',
    no: 'No',
    ok: 'OK',
    done: 'Fet',
    select: 'Seleccionar',
    selectAll: 'Seleccionar-ho tot',
    deselectAll: 'Desseleccionar-ho tot',
    noResults: 'No s\'han trobat resultats',
    noData: 'No hi ha dades disponibles',
    required: 'Obligatori',
    optional: 'Opcional',
    actions: 'Accions',
    details: 'Detalls',
    overview: 'Resum general',
    summary: 'Resum',
    total: 'Total',
    all: 'Tots',
    none: 'Cap',
    name: 'Nom',
    type: 'Tipus',
    status: 'Estat',
    date: 'Data',
    time: 'Hora',
    description: 'Descripció',
    notes: 'Notes',
    comments: 'Comentaris',
    category: 'Categoria',
    priority: 'Prioritat',
    nation: 'Nació',
    country: 'País',
    email: 'Correu electrònic',
    phone: 'Telèfon',
    address: 'Adreça',
    location: 'Ubicació',
    coordinates: 'Coordenades',
    latitude: 'Latitud',
    longitude: 'Longitud',
    from: 'Des de',
    to: 'Fins a',
    createdAt: 'Creat',
    updatedAt: 'Actualitzat',
    createdBy: 'Creat per',
    modifiedBy: 'Modificat per',
    active: 'Actiu',
    inactive: 'Inactiu',
    enabled: 'Activat',
    disabled: 'Desactivat',
    showing: 'Mostrant',
    of: 'de',
    page: 'Pàgina',
    perPage: 'per pàgina',
    rows: 'files',
    items: 'elements',
    results: 'resultats',
    sortBy: 'Ordenar per',
    ascending: 'Ascendent',
    descending: 'Descendent',
    viewAll: 'Veure-ho tot',
    viewDetails: 'Veure detalls',
    goBack: 'Tornar enrere',
    learnMore: 'Més informació',
    seeMore: 'Veure\'n més',
    showMore: 'Mostrar-ne més',
    showLess: 'Mostrar-ne menys',
    expandAll: 'Expandir-ho tot',
    collapseAll: 'Replegar-ho tot',
    copied: 'Copiat!',
    saved: 'Desat!',
    deleted: 'Eliminat!',
    updated: 'Actualitzat!',
    created: 'Creat!',
    success: 'Èxit',
    warning: 'Avís',
    info: 'Informació',
    danger: 'Perill',
    unknown: 'Desconegut',
    notAvailable: 'N/D',
    never: 'Mai',
    today: 'Avui',
    yesterday: 'Ahir',
    tomorrow: 'Demà',
    now: 'Ara',
    ago: 'fa',
    justNow: 'ara mateix',
    minutesAgo: 'fa {{count}}m',
    hoursAgo: 'fa {{count}}h',
    daysAgo: 'fa {{count}}d',
    monthsAgo: 'fa {{count}}me',
    id: 'ID',
    version: 'Versió',
    language: 'Llengua',
    theme: 'Tema',
    darkMode: 'Mode fosc',
    lightMode: 'Mode clar',
    failedToLoad: 'No s\'han pogut carregar les dades',
    failedToSave: 'No s\'ha pogut desar',
    failedToDelete: 'No s\'ha pogut eliminar',
    failedToUpdate: 'No s\'ha pogut actualitzar',
    confirmDelete: 'Esteu segur que voleu eliminar-ho?',
    confirmAction: 'N\'esteu segur?',
    unsavedChanges: 'Teniu canvis sense desar. Esteu segur que voleu sortir?',
    pageNotFound: '404 — Pàgina no trobada',
    pageNotFoundDesc: 'La pàgina que cerqueu no existeix.',
    backToDashboard: 'Tornar al tauler',
    characters: 'caràcters',
    maxCharacters: 'Màxim {{max}} caràcters',
    remaining: '{{count}} restants',
    selected: '{{count}} seleccionats',
    of_total: '{{count}} de {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Capçalera, barra lateral, menús
  // ============================================================
  nav: {
    dashboard: 'Tauler',
    requests: 'Sol·licituds',
    transports: 'Transports',
    myPatients: 'Els meus pacients',
    statistics: 'Estadístiques',
    flow: 'Flux',
    resources: 'Resources',
    exercise: 'Exercici',
    administration: 'Administració',
    map: 'Mapa',
    info: 'Informació',
    users: 'Usuaris',
    assets: 'Recursos',
    hubs: 'Centres de connexió',
    treatmentFacilities: 'Centres de tractament',
    patientImport: 'Importació de pacients',
    assetTemplates: 'Plantilles de recursos',
    dayTemplates: 'Plantilles de dies',
    announcementTicker: 'Banda d\'anuncis',
    exerciseStatistics: 'Estadístiques de l\'exercici',
    settings: 'Configuració',
    auditLog: 'Registre d\'auditoria',
    exerciseControl: 'Control de l\'exercici',
    dataSync: 'Sincronització de dades',
    documentation: 'Documentació',
    support: 'Suport',
    about: 'Quant a',
    assetContracts: 'Asset Contracts',
    notifications: 'Notificacions',
    schedules: 'Horaris',
    capacityPlanning: 'Planificació de capacitat',
    transportPlanning: 'Planificació de transports',
    transportBooking: 'Reserva de transports',
    flowDiagram: 'Diagrama de flux',
    changePassword: 'Canviar contrasenya',
    missions: 'Missions',
    startPoints: 'Punts d\'inici',
    hospital: 'Hospital',
  },

  // ============================================================
  // AUTH — Inici de sessió, contrasenya, sessió
  // ============================================================
  auth: {
    login: 'Iniciar sessió',
    logout: 'Tancar sessió',
    logoutNow: 'Tancar sessió ara',
    loggingIn: 'Iniciant sessió...',
    loginFailed: 'No s\'ha pogut iniciar sessió',
    email: 'Correu electrònic',
    password: 'Contrasenya',
    username: 'Nom d\'usuari',
    enterEmail: 'Introduïu la vostra adreça de correu electrònic',
    enterPassword: 'Introduïu la vostra contrasenya',
    enterUsername: 'Introduïu el vostre nom d\'usuari',
    forgotPassword: 'Heu oblidat la contrasenya?',
    forgotPasswordTitle: 'Contrasenya oblidada',
    forgotPasswordDesc: 'Introduïu el vostre nom d\'usuari i adreça de correu electrònic. Si ambdós coincideixen, els administradors seran notificats per restablir la vostra contrasenya.',
    requestPasswordReset: 'Sol·licitar restabliment de contrasenya',
    sending: 'Enviant...',
    backToLogin: 'Tornar a l\'inici de sessió',
    pleaseWait: 'Si us plau, espereu abans de tornar-ho a provar.',
    requestFailed: 'La sol·licitud ha fallat',
    credentialsMatch: 'Si les credencials coincideixen, els administradors han estat notificats.',
    forAccess: 'Per accedir-hi, poseu-vos en contacte amb l\'administrador del sistema.',
    changePassword: 'Canviar contrasenya',
    currentPassword: 'Contrasenya actual',
    newPassword: 'Nova contrasenya',
    confirmPassword: 'Confirmar contrasenya',
    passwordChanged: 'La contrasenya s\'ha canviat correctament',
    passwordMismatch: 'Les contrasenyes no coincideixen',
    passwordTooShort: 'La contrasenya ha de tenir almenys 8 caràcters',
    changingPassword: 'Canviant...',
    mustChangePassword: 'Heu de canviar la contrasenya abans de continuar.',
    sessionExpiring: 'La sessió està expirant',
    sessionExpireText: 'La vostra sessió expirarà en <strong>{{time}}</strong>. Si us plau, deseu la vostra feina i torneu a iniciar sessió per continuar.',
    dismiss: 'Descartar',
    switchNation: 'Canviar de nació',
    returnTo: 'Tornar a {{nation}}',
    viewingAs: 'Esteu visualitzant com a',
    loggedInAs: 'sessió iniciada com a {{nation}}',
    trainingMode: 'NOMÉS PER A FINALITATS D\'ENTRENAMENT',
    dedication: 'Creat amb amor i dedicació a la professió',
  },

  // ============================================================
  // ROLES — Rols d'usuari i etiquetes
  // ============================================================
  roles: {
    admin: 'Administrador del sistema',
    excon: 'Controlador de l\'exercici',
    eu: 'Coordinador de la UE',
    planner: 'Planificador',
    hub: 'Gestor de centre',
    nation: 'Nació',
    readOnly: 'Només lectura',
    systemAdmin: 'Administrador del sistema',
    transportPlanner: 'Planificador de transports',
    systemRoles: 'Rols del sistema',
  },

  // ============================================================
  // STATUS — Estats de sol·licituds, ofertes, missions
  // ============================================================
  status: {
    draft: 'Esborrany',
    underReview: 'En revisió',
    published: 'Publicat',
    underSelection: 'En selecció',
    accepted: 'Acceptat',
    planned: 'Planificat',
    inTransit: 'En trànsit',
    completed: 'Completat',
    closed: 'Tancat',
    withdrawn: 'Retirat',
    pending: 'Pendent',
    rejected: 'Rebutjat',
    cancelled: 'Cancel·lat',
    active: 'Actiu',
    inactive: 'Inactiu',
    review: 'Revisió',
    selection: 'Selecció',
    transit: 'Trànsit',
  },

  // ============================================================
  // CATEGORIES — Categories de sol·licituds
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personal',
    material: 'Material',
    equipment: 'Equipament',
    other: 'Altres',
    news: 'Notícies',
  },

  // ============================================================
  // URGENCY — Nivells d'urgència
  // ============================================================
  urgency: {
    routine: 'Rutinari',
    priority: 'Prioritari',
    urgent: 'Urgent',
    immediate: 'Immediat',
  },

  // ============================================================
  // ASSETS — Tipus de recursos de transport
  // ============================================================
  assetTypes: {
    train: 'Tren',
    ship: 'Vaixell',
    aircraft: 'Aeronau',
    bus: 'Autobús',
    ambulance: 'Ambulància',
    drone: 'Dron',
    helicopter: 'Helicòpter',
    ferry: 'Ferri',
    other: 'Altres',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Tauler',
    goodMorning: 'Bon dia',
    goodAfternoon: 'Bona tarda',
    goodEvening: 'Bon vespre',
    lastLogin: 'Últim inici de sessió',
    infrastructure: 'Infraestructura',
    transportAssets: 'Recursos de transport',
    treatmentFacilities: 'Centres de tractament',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Estadístiques de sol·licituds',
    viewAllRequests: 'Veure totes les sol·licituds',
    availableAssets: 'Recursos disponibles',
    seated: 'Asseguts',
    lying: 'Ajaguts',
    intensive: 'Cures intensives',
    notifications: 'Notificacions',
    markAllRead: 'Marcar-ho tot com a llegit',
    noNotifications: 'Encara no hi ha notificacions',
    notifiedWhenActivity: 'Se us notificarà quan hi hagi nova activitat',
    viewDetailsBtn: 'Veure detalls',
    nationUsers: 'Usuaris de la nació',
    user: 'Usuari',
    roles: 'Rols',
    noUsersFound: 'No s\'han trobat usuaris',
    participatingNations: 'Nacions participants',
    exerciseDisclaimer: 'Aquest sistema és només per a ús d\'exercicis. Introduïu exclusivament dades d\'exercici simulades. Els fluxos de treball estan adaptats a l\'escenari de l\'exercici i poden diferir dels procediments reals. Les normes de seguretat informàtica i protecció de dades segueixen sent plenament aplicables.',
    notConfigured: 'No configurat',
    requestCount: '{{count}} sol·licitud(s)',
    clickToView: 'Feu clic per veure',
    systemAdministration: 'Administració del sistema',
    exerciseControlTitle: 'Control de l\'exercici',
    euCoordination: 'Coordinació de la UE',
    transportPlanningTitle: 'Planificació de transports',
    hubManagement: 'Gestió de centres',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Nova sol·licitud',
    myDrafts: 'Els meus esborranys',
    pendingReview: 'Pendents de revisió',
    activeTransports: 'Transports actius',
    myPatients: 'Els meus pacients',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Sol·licituds',
    newRequest: 'Nova sol·licitud',
    createRequest: 'Crear sol·licitud',
    editRequest: 'Editar sol·licitud',
    requestDetail: 'Detall de la sol·licitud',
    requestId: 'ID de sol·licitud',
    fromNation: 'De la nació',
    toNation: 'A la nació',
    requestingNation: 'Nació sol·licitant',
    receivingNation: 'Nació receptora',
    category: 'Categoria',
    urgency: 'Urgència',
    status: 'Estat',
    patients: 'Pacients',
    patientCount: 'Nombre de pacients',
    offers: 'Ofertes',
    offerCount: 'Nombre d\'ofertes',
    created: 'Creat',
    updated: 'Actualitzat',
    submittedBy: 'Enviat per',
    reviewedBy: 'Revisat per',
    description: 'Descripció',
    medicalDetails: 'Detalls mèdics',
    transportDetails: 'Detalls de transport',
    additionalInfo: 'Informació addicional',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Punt de sortida',
    arrivalPoint: 'Punt d\'arribada',
    estimatedDeparture: 'Sortida estimada',
    estimatedArrival: 'Arribada estimada',
    submitForReview: 'Enviar per a revisió',
    publish: 'Publicar',
    startSelection: 'Iniciar selecció',
    acceptOffer: 'Acceptar oferta',
    markInTransit: 'Marcar en trànsit',
    markCompleted: 'Marcar com a completat',
    closeRequest: 'Tancar sol·licitud',
    withdrawRequest: 'Retirar sol·licitud',
    withdraw: 'Retirar',
    revertToDraft: 'Tornar a esborrany',
    deleteRequest: 'Eliminar sol·licitud',
    duplicateRequest: 'Duplicar sol·licitud',
    createFollowUp: 'Crear sol·licitud consolidada',
    followUpRequest: 'Sol·licitud consolidada',
    parentRequest: 'Sol·licitud original',
    childRequests: 'Sol·licituds consolidades',
    noRequests: 'No s\'han trobat sol·licituds',
    noOffers: 'Encara no hi ha ofertes',
    addPatient: 'Afegir pacient',
    removePatient: 'Eliminar pacient',
    patientDetails: 'Detalls del pacient',
    contactPerson: 'Persona de contacte',
    contactPhone: 'Telèfon de contacte',
    contactEmail: 'Correu de contacte',
    specialRequirements: 'Requisits especials',
    medicalEquipment: 'Equipament mèdic',
    accompaniment: 'Acompanyament',
    timeline: 'Cronologia',
    history: 'Historial',
    addComment: 'Afegir comentari',
    writeComment: 'Escriviu un comentari...',
    postComment: 'Publicar comentari',
    posting: 'Publicant...',
    noComments: 'Encara no hi ha comentaris',
    coverageBar: 'Cobertura',
    covered: 'cobert',
    uncovered: 'descobert',
    filterByStatus: 'Filtrar per estat',
    filterByCategory: 'Filtrar per categoria',
    filterByNation: 'Filtrar per nació',
    searchRequests: 'Cercar sol·licituds...',
    confirmWithdraw: 'Esteu segur que voleu retirar aquesta sol·licitud?',
    confirmDelete: 'Esteu segur que voleu eliminar aquesta sol·licitud?',
    confirmPublish: 'Esteu segur que voleu publicar aquesta sol·licitud? Serà visible per a totes les nacions.',
    confirmStartSelection: 'Esteu segur que voleu iniciar la selecció? Les nacions podran fer ofertes.',
    warningStartSelection: 'Iniciar la selecció farà visible aquesta sol·licitud a totes les nacions participants. Podran enviar ofertes per als pacients d\'aquesta sol·licitud. Aquesta acció no es pot desfer.',
    warningMakeOffer: 'En enviar aquesta oferta, comprometeu la vostra nació a proporcionar l\'assistència proposada. Aquesta acció notificarà la nació sol·licitant i el control de l\'exercici.',
    saveDraft: 'Desar esborrany',
    saving: 'Desant...',
    saveAndSubmit: 'Desar i enviar',
    step: 'Pas {{number}}',
    generalInfo: 'Informació general',
    patientInfo: 'Informació del pacient',
    logisticsInfo: 'Informació logística',
    reviewSubmit: 'Revisar i enviar',
    requestTitle: 'Títol de la sol·licitud',
    requestDescription: 'Descripció de la sol·licitud',
    numberOfPatients: 'Nombre de pacients',
    typeOfAssistance: 'Tipus d\'assistència',
    medicalTreatment: 'Tractament mèdic',
    transportAssistance: 'Assistència de transport',
    both: 'Ambdós',
    treatmentOnly: 'Només tractament',
    transportOnly: 'Només transport',
    validationErrors: 'Si us plau, corregiu els errors següents:',
    fieldRequired: 'Aquest camp és obligatori',
    selectExitHub: 'Seleccioneu un centre de sortida',
    createExitHub: 'Crear centre de sortida',
    backToRequests: 'Tornar a les sol·licituds',
    noRequestsFound: 'No s\'han trobat sol·licituds',
    createFirstRequest: 'Creeu la vostra primera sol·licitud per començar',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Ofertes',
    createOffer: 'Crear oferta',
    makeOffer: 'Fer oferta',
    manageOffers: 'Gestionar ofertes',
    offerDetail: 'Detall de l\'oferta',
    offerId: 'ID de l\'oferta',
    offeringNation: 'Nació oferent',
    offerType: 'Tipus d\'oferta',
    treatment: 'Tractament',
    transport: 'Transport',
    combined: 'Combinada',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Oferta de tractament',
    transportOffer: 'Oferta de transport',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Seleccionar pacients',
    selectedPatients: 'Pacients seleccionats',
    patientSelection: 'Selecció de pacients',
    offerConfiguration: 'Configuració de l\'oferta',
    reviewOffer: 'Revisar oferta',
    submitOffer: 'Enviar oferta',
    submitting: 'Enviant...',
    acceptOffer: 'Acceptar oferta',
    rejectOffer: 'Rebutjar oferta',
    withdrawOffer: 'Retirar oferta',
    noOffers: 'No hi ha ofertes disponibles',
    noOffer: 'No Offer',
    offerStatus: 'Estat de l\'oferta',
    offerDate: 'Data de l\'oferta',
    transportAsset: 'Recurs de transport',
    departureDate: 'Data de sortida',
    arrivalDate: 'Data d\'arribada',
    treatmentFacility: 'Centre de tractament',
    capacity: 'Capacitat',
    availableCapacity: 'Capacitat disponible',
    totalCapacity: 'Capacitat total',
    selectAsset: 'Seleccionar recurs',
    selectFacility: 'Seleccionar centre',
    offerNotes: 'Notes de l\'oferta',
    confirmAccept: 'Esteu segur que voleu acceptar aquesta oferta?',
    confirmReject: 'Esteu segur que voleu rebutjar aquesta oferta?',
    extendTransport: 'Ampliar transport',
    transportExtension: 'Ampliació de transport',
    comparisonView: 'Vista comparativa',
    shortlist: 'Llista curta',
    addToShortlist: 'Afegir a la llista curta',
    removeFromShortlist: 'Eliminar de la llista curta',
    leaveConfirmTitle: 'Voleu sortir d\'aquesta pàgina?',
    leaveConfirmMessage: 'Teniu canvis sense desar. Esteu segur que voleu sortir?',
    stayOnPage: 'Quedar-se a la pàgina',
    leavePage: 'Sortir de la pàgina',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transports',
    missionDetail: 'Detall del transport',
    missionId: 'ID de transport',
    missionStatus: 'Estat del transport',
    createMission: 'Crear transport',
    overview: 'Resum general',
    patientsTab: 'Pacients',
    transportsTab: 'Trams de transport',
    treatmentTab: 'Tractament',
    reviewTab: 'Revisió',
    departure: 'Sortida',
    arrival: 'Arribada',
    origin: 'Origen',
    destination: 'Destinació',
    stops: 'Parades',
    addStop: 'Afegir parada',
    removeStop: 'Eliminar parada',
    stopName: 'Nom de la parada',
    stopType: 'Tipus de parada',
    estimatedTime: 'Hora estimada',
    actualTime: 'Hora real',
    asset: 'Recurs',
    driver: 'Conductor',
    crew: 'Tripulació',
    noMissions: 'No s\'han trobat transports',
    completeMission: 'Completar transport',
    cancelMission: 'Cancel·lar transport',
    startTransport: 'Iniciar transport',
    missionChain: 'Cadena de transport',
    linkedMissions: 'Transports vinculats',
    handover: 'Traspàs',
    handoverPoint: 'Punt de traspàs',
    pickupPoint: 'Punt de recollida',
    dropoffPoint: 'Punt de lliurament',
    searchTransports: 'Cercar transports...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pacients',
    myPatients: 'Els meus pacients',
    patientId: 'ID del pacient',
    firstName: 'Nom',
    lastName: 'Cognoms',
    dateOfBirth: 'Data de naixement',
    age: 'Edat',
    gender: 'Gènere',
    male: 'Masculí',
    female: 'Femení',
    other: 'Altres',
    nationality: 'Nacionalitat',
    diagnosis: 'Diagnòstic',
    condition: 'Estat',
    stable: 'Estable',
    critical: 'Crític',
    serious: 'Greu',
    treatmentNeeded: 'Tractament necessari',
    allergies: 'Al·lèrgies',
    medications: 'Medicaments',
    bloodType: 'Grup sanguini',
    weight: 'Pes (kg)',
    infectious: 'Infecciós',
    mentalHealth: 'Salut mental',
    mobility: 'Mobilitat',
    ambulatory: 'Ambulatori',
    wheelchair: 'Cadira de rodes',
    stretcher: 'Llitera',
    intensive: 'Cures intensives',
    oxygenRequired: 'Oxigen necessari',
    ventilator: 'Ventilador',
    medicalEscort: 'Escorta mèdica',
    noPatients: 'No s\'han trobat pacients',
    patientDetails: 'Detalls del pacient',
    medicalHistory: 'Historial mèdic',
    travelDocuments: 'Documents de viatge',
    passport: 'Passaport',
    pseudonymizedId: 'ID pseudonimitzat',
    sensitiveData: 'Dades sensibles',
    journey: 'Trajecte del pacient',
    assignedTo: 'Assignat a',
    currentLocation: 'Ubicació actual',
    importPatients: 'Importar pacients',
    exportPatients: 'Exportar pacients',
    seated: 'Assegut',
    lying: 'Ajagut',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Usuaris',
    createUser: 'Crear usuari',
    editUser: 'Editar usuari',
    deleteUser: 'Eliminar usuari',
    username: 'Nom d\'usuari',
    displayName: 'Nom visible',
    email: 'Correu electrònic',
    password: 'Contrasenya',
    role: 'Rol',
    roles: 'Rols',
    nation: 'Nació',
    active: 'Actiu',
    lastLogin: 'Últim inici de sessió',
    createdAt: 'Creat',
    isNation: 'Nació',
    isEU: 'UE',
    isAdmin: 'Administrador',
    isExcon: 'EXCON',
    isPlanner: 'Planificador',
    isHub: 'Centre',
    isReadOnly: 'Només lectura',
    noUsers: 'No s\'han trobat usuaris',
    confirmDelete: 'Esteu segur que voleu eliminar aquest usuari?',
    resetPassword: 'Restablir contrasenya',
    generatePassword: 'Generar contrasenya',
    searchUsers: 'Cercar usuaris...',
    userCreated: 'L\'usuari s\'ha creat correctament',
    userUpdated: 'L\'usuari s\'ha actualitzat correctament',
    userDeleted: 'L\'usuari s\'ha eliminat correctament',
    selectNation: 'Seleccioneu una nació',
    mustChangePassword: 'Ha de canviar la contrasenya al pròxim inici de sessió',
    flagImage: 'Imatge de la bandera',
    exportUsers: 'Exportar usuaris',
    importUsers: 'Importar usuaris',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Recursos',
    createAsset: 'Crear recurs',
    editAsset: 'Editar recurs',
    deleteAsset: 'Eliminar recurs',
    assetName: 'Nom del recurs',
    assetType: 'Tipus de recurs',
    capacitySeated: 'Capacitat (asseguts)',
    capacityLying: 'Capacitat (ajaguts)',
    capacityIntensive: 'Capacitat (cures intensives)',
    owner: 'Propietari',
    operator: 'Operador',
    baseLocation: 'Ubicació base',
    range: 'Autonomia',
    speed: 'Velocitat',
    noAssets: 'No s\'han trobat recursos',
    confirmDelete: 'Esteu segur que voleu eliminar aquest recurs?',
    searchAssets: 'Cercar recursos...',
    assetCreated: 'El recurs s\'ha creat correctament',
    assetUpdated: 'El recurs s\'ha actualitzat correctament',
    assetDeleted: 'El recurs s\'ha eliminat correctament',
    exportAssets: 'Exportar recursos',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Centres de connexió',
    startPoints: 'Punts d\'inici',
    createHub: 'Crear centre',
    editHub: 'Editar centre',
    deleteHub: 'Eliminar centre',
    hubName: 'Nom del centre',
    hubType: 'Tipus de centre',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Centre d\'entrada',
    airport: 'Aeroport',
    seaport: 'Port marítim',
    railStation: 'Estació de tren',
    roadPoint: 'Punt de carretera',
    ucpmClassification: 'Classificació UCPM',
    icaoCode: 'Codi ICAO',
    iataCode: 'Codi IATA',
    noHubs: 'No s\'han trobat centres',
    confirmDelete: 'Esteu segur que voleu eliminar aquest centre?',
    searchHubs: 'Cercar centres...',
    nationAssignment: 'Assignació de nacions',
    assignNations: 'Assignar nacions',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Centres de tractament',
    createFacility: 'Crear centre',
    editFacility: 'Editar centre',
    deleteFacility: 'Eliminar centre',
    facilityName: 'Nom del centre',
    facilityType: 'Tipus de centre',
    hospitalName: 'Nom de l\'hospital',
    bedCapacity: 'Capacitat de llits',
    specialties: 'Especialitats',
    availableBeds: 'Llits disponibles',
    totalBeds: 'Total de llits',
    contactPerson: 'Persona de contacte',
    noFacilities: 'No s\'han trobat centres de tractament',
    confirmDelete: 'Esteu segur que voleu eliminar aquest centre?',
    searchFacilities: 'Cercar centres...',
    hubNationAssignment: 'Assignació de nacions als centres',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Horaris',
    createSchedule: 'Crear horari',
    editSchedule: 'Editar horari',
    deleteSchedule: 'Eliminar horari',
    scheduleName: 'Nom de l\'horari',
    scheduleType: 'Tipus d\'horari',
    recurring: 'Recurrent',
    oneTime: 'Puntual',
    frequency: 'Freqüència',
    daily: 'Diari',
    weekly: 'Setmanal',
    startDate: 'Data d\'inici',
    endDate: 'Data de fi',
    departureTime: 'Hora de sortida',
    arrivalTime: 'Hora d\'arribada',
    stops: 'Parades',
    addStop: 'Afegir parada',
    noSchedules: 'No s\'han trobat horaris',
    bookings: 'Reserves',
    timeline: 'Cronologia',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Notificacions',
    markAllRead: 'Marcar-ho tot com a llegit',
    markAsRead: 'Marcar com a llegit',
    markAsUnread: 'Marcar com a no llegit',
    noNotifications: 'No hi ha notificacions',
    viewAll: 'Veure totes les notificacions',
    settings: 'Configuració de notificacions',
    emailNotifications: 'Notificacions per correu',
    inAppNotifications: 'Notificacions dins l\'aplicació',
    notifyOn: 'Notificar-me sobre',
    requestCreated: 'Nova sol·licitud',
    requestPublished: 'Sol·licitud publicada',
    requestClosed: 'Sol·licitud tancada',
    requestCompleted: 'Sol·licitud completada',
    commentAdded: 'Nou comentari',
    offerReceived: 'Oferta rebuda',
    offerAccepted: 'Oferta acceptada',
    statusChanged: 'Estat canviat',
    selectionStarted: 'Selecció iniciada',
    missionCreated: 'Transport creat',
    missionStatusUpdated: 'Transport actualitzat',
    transportPartnerNamed: 'Soci de transport',
    transportExtensionReceived: 'Ampliació de transport',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Configuració',
    general: 'General',
    system: 'Sistema',
    email: 'Correu electrònic',
    sync: 'Sincronització',
    security: 'Seguretat',
    appearance: 'Aparença',
    systemName: 'Nom del sistema',
    systemEmail: 'Correu del sistema',
    maintenanceMode: 'Mode de manteniment',
    readOnlyMode: 'Mode de només lectura',
    emailEnabled: 'Correu activat',
    smtpHost: 'Servidor SMTP',
    smtpPort: 'Port SMTP',
    smtpUser: 'Usuari SMTP',
    smtpPassword: 'Contrasenya SMTP',
    senderEmail: 'Correu del remitent',
    senderName: 'Nom del remitent',
    testEmail: 'Enviar correu de prova',
    syncEnabled: 'Sincronització activada',
    syncUrl: 'URL de sincronització',
    syncApiKey: 'Clau API de sincronització',
    settingsSaved: 'La configuració s\'ha desat correctament',
    helpdesk: 'Servei d\'atenció',
    helpdeskTitle: 'Títol del servei d\'atenció',
    helpdeskEmail: 'Correu del servei d\'atenció',
    helpdeskPhone: 'Telèfon del servei d\'atenció',
    helpdeskInfo: 'Informació del servei d\'atenció',
    realLifeSupport: 'Suport en situació real',
    trainingMode: 'Mode d\'entrenament',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Registres d\'auditoria',
    action: 'Acció',
    user: 'Usuari',
    target: 'Objectiu',
    details: 'Detalls',
    timestamp: 'Marca de temps',
    ipAddress: 'Adreça IP',
    noLogs: 'No s\'han trobat registres d\'auditoria',
    searchLogs: 'Cercar registres...',
    filterByAction: 'Filtrar per acció',
    filterByUser: 'Filtrar per usuari',
    exportLogs: 'Exportar registres',
    exportCsv: 'Exportar CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Control de l\'exercici',
    currentDay: 'Dia actual',
    exerciseDay: 'Dia de l\'exercici',
    nextDay: 'Dia següent',
    previousDay: 'Dia anterior',
    resetExercise: 'Restablir exercici',
    startExercise: 'Iniciar exercici',
    endExercise: 'Finalitzar exercici',
    dayReset: 'Restabliment del dia',
    confirmReset: 'Esteu segur que voleu restablir el dia de l\'exercici? Això esborrarà totes les dades del dia actual.',
    resetInProgress: 'Restabliment en curs...',
    maintenanceMode: 'Mode de manteniment',
    enableMaintenance: 'Activar manteniment',
    disableMaintenance: 'Desactivar manteniment',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Sincronització de dades',
    syncStatus: 'Estat de la sincronització',
    lastSync: 'Última sincronització',
    pendingItems: 'Elements pendents',
    syncNow: 'Sincronitzar ara',
    syncing: 'Sincronitzant...',
    syncSuccess: 'La sincronització s\'ha completat correctament',
    syncFailed: 'La sincronització ha fallat',
    outbox: 'Safata de sortida',
    inbox: 'Safata d\'entrada',
    configuration: 'Configuració',
    targetUrl: 'URL de destinació',
    apiKey: 'Clau API',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Mapa',
    layers: 'Capes',
    requests: 'Sol·licituds',
    hubs: 'Centres',
    facilities: 'Centres de tractament',
    routes: 'Rutes',
    showAll: 'Mostrar-ho tot',
    hideAll: 'Amagar-ho tot',
    zoomIn: 'Ampliar',
    zoomOut: 'Reduir',
    resetView: 'Restablir vista',
    satellite: 'Satèl·lit',
    terrain: 'Terreny',
    offline: 'Fora de línia',
    online: 'En línia',
    tilesOffline: 'Les tessel·les del mapa es serveixen localment',
    tilesOnline: 'Les tessel·les del mapa es carreguen des de servidors en línia',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Estadístiques',
    overview: 'Resum general',
    requestsByStatus: 'Sol·licituds per estat',
    requestsByCategory: 'Sol·licituds per categoria',
    requestsByNation: 'Sol·licituds per nació',
    offersByStatus: 'Ofertes per estat',
    patientsByCondition: 'Pacients per estat',
    transportsByStatus: 'Transports per estat',
    timeline: 'Cronologia',
    totalRequests: 'Total de sol·licituds',
    totalOffers: 'Total d\'ofertes',
    totalPatients: 'Total de pacients',
    totalTransports: 'Total de transports',
    averageResponseTime: 'Temps de resposta mitjà',
    completionRate: 'Taxa de completació',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Estadístiques de l\'exercici',
    overview: 'Resum general',
    byCategory: 'Per categoria',
    byNation: 'Per nació',
    byDay: 'Per dia',
    totalPatientsMoved: 'Total de pacients traslladats',
    totalRequestsProcessed: 'Total de sol·licituds processades',
    averageProcessingTime: 'Temps de processament mitjà',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Diagrama de flux',
    sankey: 'Sankey',
    nodeGraph: 'Graf de nodes',
    refresh: 'Actualitzar',
    noData: 'No hi ha dades de flux disponibles',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Quant a',
    version: 'Versió',
    systemInfo: 'Informació del sistema',
    buildDate: 'Data de compilació',
    environment: 'Entorn',
    description: 'ARCOS — Sistema avançat de comunicació de sol·licituds',
    subtitle: 'Assistència a víctimes i operacions mèdiques',
    whatIsArcos: 'Què és ARCOS? – Explicació per als participants de l\'exercici',
    arcosDesc1: 'ARCOS és una eina digital utilitzada en aquest exercici per donar suport i estructurar la comunicació internacional, les sol·licituds i els processos de coordinació entre els actors participants.',
    arcosDesc2: 'ARCOS proporciona una representació simplificada i orientada a l\'exercici dels principis bàsics d\'aquests sistemes.',
    arcosUsedFor: 'Durant l\'exercici, ARCOS s\'utilitza per representar processos típics com:',
    arcosUsedForItem1: 'presentació i gestió de sol·licituds d\'assistència,',
    arcosUsedForItem2: 'coordinació i resposta a ofertes de suport d\'altres nacions,',
    arcosUsedForItem3: 'seguiment de l\'estat i progrés de les sol·licituds,',
    arcosUsedForItem4: 'i representació simplificada de fluxos de transport o evacuació.',
    arcosDesc3: 'Els fluxos de treball a ARCOS estan intencionadament simplificats i adaptats als objectius de formació específics de l\'exercici.',
    arcosDesc4: 'L\'objectiu d\'ARCOS no és simular un sistema real perfecte o complet.',
    arcosDesc5: 'Si certs elements o fluxos de treball difereixen dels procediments reals que pugui conèixer, això és esperat.',
    facilitatedBy: 'Facilitat per MMCC-E',
    dhcInitiative: 'El Digital Health Corner (DHC) és una iniciativa conjunta de:',
    dhcAuthor1: 'Sven Giegerich — Forces Armades Alemanyes',
    dhcAuthor2: 'Mohamad Haji — Defensa Belga',
    dhcConviction: 'Nascuda de la convicció que la innovació prospera on la passió es troba amb el pragmatisme.',
    dhcInspired: 'Inspirats per la guspira inicial del MMCC-E, ens vam proposar crear solucions simples però efectives.',
    dhcLove: 'Ho fem perquè estimem la nostra feina i creiem que les idees digitals poden transformar la col·laboració en salut militar.',
    dhcOpen: 'El DHC és una plataforma oberta: lliure de jerarquies, oberta a idees, moguda per la curiositat.',
    dhcClosing: 'Digital Health Corner – on la curiositat es troba amb la col·laboració.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Documentació',
    gettingStarted: 'Primers passos',
    userGuide: 'Guia de l\'usuari',
    faq: 'Preguntes freqüents',
    troubleshooting: 'Resolució de problemes',
    apiReference: 'Referència de l\'API',
    downloadTemplate: 'Descarregar plantilla',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Importació de pacients',
    uploadFile: 'Pujar fitxer',
    selectFile: 'Seleccionar fitxer',
    preview: 'Vista prèvia',
    importNow: 'Importar ara',
    importing: 'Important...',
    importSuccess: '{{count}} pacients importats correctament',
    importFailed: 'La importació ha fallat',
    downloadTemplate: 'Descarregar plantilla',
    dragDrop: 'Arrossegueu i deixeu anar un fitxer aquí, o feu clic per seleccionar',
    supportedFormats: 'Formats compatibles: XLSX, XLS, CSV',
    rowsFound: '{{count}} files trobades',
    validRows: '{{count}} files vàlides',
    invalidRows: '{{count}} files no vàlides',
    duplicateRows: '{{count}} files duplicades',
    previewData: 'Vista prèvia de les dades',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Planificació de transports',
    planRoute: 'Planificar ruta',
    routeBuilder: 'Constructor de rutes',
    addWaypoint: 'Afegir punt intermedi',
    removeWaypoint: 'Eliminar punt intermedi',
    estimatedDuration: 'Durada estimada',
    distance: 'Distància',
    selectVehicle: 'Seleccionar vehicle',
  },

  transportBooking: {
    title: 'Reserva de transports',
    bookTransport: 'Reservar transport',
    availableSlots: 'Places disponibles',
    bookingConfirmed: 'Reserva confirmada',
    cancelBooking: 'Cancel·lar reserva',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Planificació de capacitat',
    totalCapacity: 'Capacitat total',
    usedCapacity: 'Capacitat utilitzada',
    availableCapacity: 'Capacitat disponible',
    utilizationRate: 'Taxa d\'utilització',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Plantilles de recursos',
    dayTemplates: 'Plantilles de dies',
    createTemplate: 'Crear plantilla',
    editTemplate: 'Editar plantilla',
    deleteTemplate: 'Eliminar plantilla',
    templateName: 'Nom de la plantilla',
    applyTemplate: 'Aplicar plantilla',
    noTemplates: 'No s\'han trobat plantilles',
    confirmDelete: 'Esteu segur que voleu eliminar aquesta plantilla?',
    confirmApply: 'Esteu segur que voleu aplicar aquesta plantilla? Això sobreescriurà les dades existents.',
    exportTemplates: 'Exportar plantilles',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Banda d\'anuncis',
    createAnnouncement: 'Crear anunci',
    editAnnouncement: 'Editar anunci',
    deleteAnnouncement: 'Eliminar anunci',
    message: 'Missatge',
    startTime: 'Hora d\'inici',
    endTime: 'Hora de fi',
    active: 'Actiu',
    noAnnouncements: 'No hi ha anuncis',
    confirmDelete: 'Esteu segur que voleu eliminar aquest anunci?',
  },

  // ============================================================
  // COMPONENTS — Cadenes de components reutilitzables
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Cercar...',
      noResults: 'No s\'han trobat resultats',
      showing: 'Mostrant {{from}} a {{to}} de {{total}}',
      rowsPerPage: 'Files per pàgina',
      previousPage: 'Pàgina anterior',
      nextPage: 'Pàgina següent',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Confirmar',
      cancel: 'Cancel·lar',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Canvis sense desar',
      message: 'Teniu canvis sense desar. Esteu segur que voleu sortir d\'aquesta pàgina?',
      stay: 'Quedar-se a la pàgina',
      leave: 'Sortir de la pàgina',
    },
    // EmptyState
    emptyState: {
      noData: 'No hi ha dades disponibles',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Alguna cosa ha anat malament',
      message: 'S\'ha produït un error inesperat. Si us plau, proveu d\'actualitzar la pàgina.',
      retry: 'Reintentar',
    },
    // ExportButton
    exportButton: {
      export: 'Exportar',
      exporting: 'Exportant...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Imprimir',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Esborrany',
      review: 'Revisió',
      published: 'Publicat',
      selection: 'Selecció',
      inTransit: 'En trànsit',
      completed: 'Completat',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Instància en línia',
      message: 'Mode de només lectura. Les dades es sincronitzen des del servidor principal.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Esteu visualitzant com a',
      loggedInAs: 'sessió iniciada com a {{nation}}',
      returnTo: 'Tornar a {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Cercar pàgines, sol·licituds, transports...',
      searching: 'Cercant...',
      noResults: 'Cap resultat per a "{{query}}"',
      navigate: 'Navegar',
      select: 'Seleccionar',
      close: 'Tancar',
      pages: {
        dashboard: 'Tauler',
        requests: 'Sol·licituds',
        transports: 'Transports',
        map: 'Mapa',
        myPatients: 'Els meus pacients',
        flowDiagram: 'Diagrama de flux',
        statistics: 'Estadístiques',
        assets: 'Recursos',
        startPoints: 'Punts d\'inici / Centres',
        treatmentFacilities: 'Centres de tractament',
        users: 'Usuaris',
        settings: 'Configuració',
        auditLogs: 'Registres d\'auditoria',
        exerciseControl: 'Control de l\'exercici',
        dataSync: 'Sincronització de dades',
        patientImport: 'Importació de pacients',
        notifications: 'Notificacions',
        documentation: 'Documentació',
      },
      actions: {
        importPatientsJson: 'Importa Pacients (JSON)',
        importPatientsExcel: 'Importa Pacients (Excel)',
        importUsers: 'Importa Usuaris (Excel)',
        importAssetTemplates: 'Importa Plantilles d\'actius (Excel)',
        importDayTemplates: 'Importa Entrades de plantilla diària (Excel)',
        exportRequests: 'Exporta Sol·licituds (Excel)',
        exportPatients: 'Exporta Pacients (Excel)',
        exportUsers: 'Exporta Usuaris (Excel)',
        exportCredentials: 'Exporta Credencials (PDF)',
        exportAuditExcel: 'Exporta Registre d\'auditoria (Excel)',
        exportAuditPdf: 'Exporta Registre d\'auditoria (PDF)',
        pagePatientImport: 'Pàgina d\'importació de pacients',
        pageRequestDetail: 'Pàgina de detalls de sol·licitud',
        pageUsers: 'Pàgina de gestió d\'usuaris',
        pageAssetTemplates: 'Pàgina de plantilles d\'actius',
        pageDayTemplates: 'Pàgina de plantilles diàries',
        pageRequests: 'Pàgina de llista de sol·licituds',
        pageAuditLogs: 'Pàgina de registre d\'auditoria',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'La sessió està expirant',
      message: 'La vostra sessió expirarà en <strong>{{time}}</strong>. Si us plau, deseu la vostra feina i torneu a iniciar sessió per continuar.',
      dismiss: 'Descartar',
      logoutNow: 'Tancar sessió ara',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Seleccioneu 4 fusos horaris',
      configure: 'Configurar fusos horaris',
      reset: 'Restablir',
      apply: 'Aplicar',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Seleccionar ubicació',
      latitude: 'Latitud',
      longitude: 'Longitud',
      clickToSelect: 'Feu clic al mapa per seleccionar una ubicació',
    },
    // Modal
    modal: {
      close: 'Tancar',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Inici',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Manteniment del sistema',
    message: 'El sistema s\'està restablint per al pròxim dia d\'exercici. Si us plau, espereu fins que el procés finalitzi.',
    autoRefresh: 'Aquesta pàgina s\'actualitzarà automàticament quan el sistema estigui disponible de nou.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Almenys 10 caràcters',
    uppercase: '1 lletra majúscula',
    lowercase: '1 lletra minúscula',
    digit: '1 dígit',
    special: '1 caràcter especial',
  },
};

export default ca;
